import { ArpeggiSupportedChain } from '@arpeggi/shared'
import { Network } from 'alchemy-sdk'

const PROD_NETWORKS: Record<ArpeggiSupportedChain, Network> = {
  ethereum: Network.ETH_MAINNET,
  polygon: Network.MATIC_MAINNET,
  optimism: Network.OPT_MAINNET
}

const DEV_NETWORKS: Record<ArpeggiSupportedChain, Network> = {
  ethereum: Network.ETH_GOERLI,
  polygon: Network.MATIC_MUMBAI,
  optimism: Network.OPT_GOERLI
}

export const getAlchemyNetwork = (chain: ArpeggiSupportedChain) => {
  if (!chain) throw Error('Chain is undefined')

  if (window.ENV === 'prod') return PROD_NETWORKS[chain]
  return DEV_NETWORKS[chain]
}
